import css from 'styled-jsx/css';

export default css.global`
  .CashbackPage {
    min-height: 70vh;
  }

  .CashbackPage__iframe {
    display: block;
    width: 100%;
    min-height: 70vh;
    border: none;
  }
`;
